import produce from 'immer';

import { sortByObjectKey } from '@utils/collections';

import { OnboardApplication } from 'types/applications';
import { ILimitSearchResult } from 'types/search';

const statusTranslationKeyMap = {
  completed: 'onboarding.applicants.status.completed',
  in_progress: 'onboarding.applicants.status.inprogress',
  not_started: 'onboarding.applicants.status.notstarted',
};

export const transformOnboardApplications = (
  data: ILimitSearchResult<Omit<OnboardApplication, 'sortedIsHiredTriggers'>>
) =>
  produce(data, (draft: ILimitSearchResult<OnboardApplication>) => {
    draft.results.forEach((applicant) => {
      applicant.isHiredTriggers.forEach((trigger) => {
        trigger.statusTranslationKey = statusTranslationKeyMap[trigger.status];
        trigger.children.forEach(
          (child) => (child.statusTranslationKey = statusTranslationKeyMap[child.status])
        );
      });
      applicant.sortedIsHiredTriggers = sortByObjectKey(applicant.isHiredTriggers, 'order', true);
    });
  }) as ILimitSearchResult<OnboardApplication>;
